import { render } from "./SymptomsResults.vue?vue&type=template&id=3b798015"
import script from "./SymptomsResults.vue?vue&type=script&lang=js"
export * from "./SymptomsResults.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__